import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { camelCase, get } from 'lodash';

import FilterGroup from 'components/search_sidebar/filter_group';
import Tag from 'components/tags/tag';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import {
  clearFilters,
  clearFiltersIfEmpty,
  clearRelated,
  toggleRole,
  setTags
} from "../store/actions/query";
import { delayRetrieveRecords } from "../store/actions/search";

export class ContactsCurrentFiltersGroup extends React.Component {
  static propTypes = {
    backToLink: PropTypes.string,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    contactRolesMappings: PropTypes.object.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    filterTags: PropTypes.array.isRequired,
    relatedContacts: PropTypes.shape({
      researchPropertyCount: PropTypes.number.isRequired
    }),
    relatedSearchId: PropTypes.number,
    relationshipFilters: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,

    onClearFilters: PropTypes.func.isRequired,
    onClearRelated: PropTypes.func.isRequired,
    onClearRelationshipFilters: PropTypes.func.isRequired,
    onSetTags: PropTypes.func.isRequired,
    onToggleFindDuplicates: PropTypes.func
  };

  getRelatedCompanyCount = () => {
    const { relatedContacts, relatedSearchId } = this.props;
    return relatedSearchId && get(relatedContacts, 'companyCount');
  };

  getRelatedPropertyCount = () => {
    const { relatedContacts, relatedSearchId } = this.props;
    return relatedSearchId && get(relatedContacts, 'researchPropertyCount');
  };

  handleClearFiltersIfEmpty = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  }

  handleRelationshipFilters = (role) => {
    const { onClearRelationshipFilters } = this.props;
    onClearRelationshipFilters(role, false);
    this.handleClearFiltersIfEmpty();
  };

  handleClearRelated = () => {
    const { onClearRelated } = this.props;
    onClearRelated();
    this.handleClearFiltersIfEmpty();
  };

  handleClearFilters = () => {
    const { onClearFilters, delayRetrieveRecords } = this.props;
    onClearFilters();
    delayRetrieveRecords();
  };

  handleSetTags = (tag) => {
    const { tags, onSetTags } = this.props;
    const newTags = tags.filter(t => t !== tag);
    onSetTags(newTags);
    this.handleClearFiltersIfEmpty();
  };

  render() {
    const tags = this.renderTags();
    return (
      <FilterGroup
        filtersApplied={tags.length > 0}
        onClearFilters={this.handleClearFilters}
      >
        <div className="top-buffer-xs">
          {tags.length > 0 &&
            <div className="current-filters-group">
              <span className="text-muted">CURRENT FILTERS: </span>
              {tags}
            </div>
          }
        </div>
      </FilterGroup>
    );
  }

  renderTags() {
    const tags = [];

    const {
      backToLink,
      contactRolesMappings,
      filterTags,
      relationshipFilters
    } = this.props;

    const relatedCompanyCount = this.getRelatedCompanyCount();
    if (relatedCompanyCount && relatedCompanyCount > 0) {
      const text = `<strong> Company Search - ${relatedCompanyCount} Companies </strong>`;
      const link = `<a href=${backToLink}>(view search)</a>`;

      tags.push(
        this.renderTag(
          'property-ids',
          <span dangerouslySetInnerHTML={{ __html: `Related to: ${text} ${link}` }}/>,
          () => this.handleClearRelated(),
          false
        )
      );
    }

    const relatedPropertyCount = this.getRelatedPropertyCount();
    if (relatedPropertyCount && relatedPropertyCount > 0) {
      const text = `<strong> Property Search - ${relatedPropertyCount} Properties </strong>`;
      const link = `<a href=${backToLink}>(view search)</a>`;

      tags.push(
        this.renderTag(
          'property-ids',
          <span dangerouslySetInnerHTML={{ __html: `Related to: ${text} ${link}` }}/>,
          () => this.handleClearRelated(),
          false
        )
      );
    }

    relationshipFilters.forEach((role) => {
      tags.push(
        this.renderTag(
          role,
          `Contact Type: ${contactRolesMappings[camelCase(role)]}`,
          () => this.handleRelationshipFilters(role)
        )
      );
    });

    filterTags.forEach((tag)=> {
      tags.push(
        this.renderTag(tag, `Tag: ${tag}`, () => this.handleSetTags(tag))
      );
    });

    if (tags.length > 0) {
      tags.push(
        <div className="clear-filter-tag clickable left-buffer-md" key="clear-all" onClick={this.handleClearFilters}>
          <FontAwesomeIcon className="right-buffer-sm" icon={faTimes} size="sm"/>
          Clear All
        </div>
      );
    }

    return tags;
  }

  renderTag(key, label, onRemove, capitalize = true) {
    return (
      <Tag capitalize={capitalize} key={key} removable={true} onRemove={onRemove}>
        {label}
      </Tag>
    );
  }
}

const mapStateToProps = state => ({
  backToLink: state.query.backToLink,
  contactRolesMappings: state.mappings.contactRoles,
  filterTags: state.query.tags,
  relatedContacts: state.search.relatedContacts,
  relatedSearchId: state.query.relatedSearchId,
  relationshipFilters: state.query.roles,
  tags: state.query.tags
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onClearFilters: clearFilters,
  onClearRelated: clearRelated,
  onClearRelationshipFilters: toggleRole,
  onSetTags: setTags
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactsCurrentFiltersGroup);
